import z from "zod";

export type EntityId<T extends string> = `${T}_${string}`;

// Runtime validator factory
export const createIdValidator = <T extends string>(entity: T) =>
  z.custom<EntityId<T>>(
    (val): val is EntityId<T> => typeof val === "string" && new RegExp(`^${entity}_[A-Za-z0-9]{20}$`).test(val),
  );

export const AssetIdSchema = createIdValidator("asset");
export type AssetId = z.infer<typeof AssetIdSchema>;

export const LabelIdSchema = createIdValidator("label");
export type LabelId = z.infer<typeof LabelIdSchema>;

export const ConceptIdSchema = createIdValidator("concept");
export type ConceptId = z.infer<typeof ConceptIdSchema>;

export const SeedIdSchema = createIdValidator("seed");
export type SeedId = z.infer<typeof SeedIdSchema>;

export const ChunkIdSchema = z.custom<`asset_${string}_${number}`>(
  (val): val is `asset_${string}_${number}` => typeof val === "string" && /^asset_[A-Za-z0-9]{20}.*_\d+$/.test(val),
);
export type ChunkId = z.infer<typeof ChunkIdSchema>;

export const ProjectIdSchema = createIdValidator("project");
export type ProjectId = z.infer<typeof ProjectIdSchema>;

export const UserIdSchema = createIdValidator("user");
export type UserId = z.infer<typeof UserIdSchema>;

export const ViewIdSchema = createIdValidator("view");
export type ViewId = z.infer<typeof ViewIdSchema>;

export const WorkspaceIdSchema = createIdValidator("workspace");
export type WorkspaceId = z.infer<typeof WorkspaceIdSchema>;

export const OrganizationIdSchema = createIdValidator("organization");
export type OrganizationId = z.infer<typeof OrganizationIdSchema>;
